import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/lib/mdbvue.css';

Vue.config.productionTip = false;

Vue.filter('firstletter', (value) => {
  if (!value) return '';
  value = value.toString();
  const splittedName = value.split(' ');
  splittedName[0] = `${value.charAt(0).toUpperCase()}.`;

  return splittedName.join(' ');
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
